import React, { Component } from 'react';
import AuthService from '../utils/AuthService';
import Input from './Input';
import Select from './Select';
import Textarea from './Textarea';

var Auth = new AuthService();

// Auth logic with routes from this example:
// https://reacttraining.com/react-router/web/example/auth-workflow
class VesselForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			disableDeadrise: false,
			applications: [],
			subApplications: [],
			commaWarning: false,
			weightWarning: false
		}

		this.Auth = new AuthService();
		this.onChange = this.onChange.bind(this);
		this.enableCommaWarning = this.enableCommaWarning.bind(this);
		this.isCatamaran = this.isCatamaran.bind(this);
	}

	componentDidMount() {
		// get applications
		this.Auth.fetch("/boat-applications")
		.then(
			(result) => {
				if(result) {
					this.setState({
						applications: result.data,
						subApplications: result.boat_sub_applications
					});
				} else {
					if(result.errors) {
						alert(result.errors.join("\n"));
					}
				}
			},
			(error) => {
				this.setState({
					error
				});
			}
		);
	}

	onChange(e) {
		const target = e.target;

		// check hull type
		if(target.name === "hullType") {
			if(target.value == 4) {
				this.setState({
					disableDeadrise: true
				});
			} else {
				this.setState({
					disableDeadrise: false
				});
			}
		} else if(target.name === "fullLoad") {
			let limit = 500; // 500 for kgs
			if(this.props.units === "English") {
				limit = 1000;
			}
			if(target.value < limit) {
				this.setState({
					weightWarning: true
				});
			} else {
				this.setState({
					weightWarning: false
				});
			}
		}

		this.props.onChange(target.name, target.value);
	}

	enableCommaWarning() {
		this.setState({
			commaWarning: true
		});
	}

	isCatamaran() {
		return (this.props.vesselInfo.subApplication + '' === "10" || this.props.vesselInfo.subApplication + '' === "34" || this.props.vesselInfo.subApplication + '' === "35");
	}

	render() {
		const { vesselInfo } = this.props;
		const { applications } = this.state;

		// convert lists to option lists for select element
		let applicationOptions = [];
		let subApplications = [];
		for(let i=0; i < applications.length; i++) {
			applicationOptions.push({
				value: applications[i].boat_app_id,
				text: applications[i].boat_application_name
			});

			if(vesselInfo.application == applications[i].boat_app_id) {
				subApplications = applications[i].sub_applications;
			}
		}

		let subApplicationOptions = [];
		for(let i=0; i < subApplications.length; i++) {
				subApplicationOptions.push({
					value: subApplications[i].sub_application_id,
					text: subApplications[i].sub_application_name
				});
		}

		subApplicationOptions.sort((a, b) => 
			a.text.localeCompare(b.text)
		);

		let disableSubApplication = true;
		if(vesselInfo.application && vesselInfo.application !== "") {
			disableSubApplication = false;
		}

		return (
			<form id="vessel-form" className="pp-sizing-form">
				<div className="pp-form-wrapper">

					<div className="pp-form-row-split">
						<Input
							type="text"
							htmlID="hull-name"
							htmlName="hullName"
							label="Hull # / Name"
							placeholderText="Hull # / Name"
							value={vesselInfo.hullName}
							onChange={this.onChange}
							disabled={this.props.disableAll || this.props.disableHullName}
							error={this.props.errors.hullName || false}
						/>
					</div>

					<div className="pp-form-row-split">
						<Select
							type="text"
							htmlID="application"
							htmlName="application"
							label="Application"
							placeholderText="Application"
							value={vesselInfo.application}
							onChange={this.onChange}
							options={applicationOptions}
							disabled={this.props.disableAll}
							error={this.props.errors.application || false}
							required
						/>
					</div>

					<div className="pp-form-row-split">
						<Select
							type="text"
							htmlID="vessel-use"
							htmlName="vesselUse"
							label="Vessel Use (Coastal/Offshore)"
							placeholderText="Vessel Use"
							value={vesselInfo.vesselUse}
							options={[{"value": "Coastal", "text": "Coastal"}, {"value": "Offshore", "text": "Offshore"}]}
							onChange={this.onChange}
							disabled={this.props.disableAll}
							error={this.props.errors.vesselUse || false}
							required
						/>
					</div>

					<div className="pp-form-row-split">
						<Select
							type="text"
							htmlID="sub-application"
							htmlName="subApplication"
							label="Sub-Application"
							placeholderText="Sub-Application"
							value={vesselInfo.subApplication}
							onChange={this.onChange}
							options={subApplicationOptions}
							disabled={disableSubApplication || this.props.disableAll}
							error={this.props.errors.subApplication || false}
							required
						/>
					</div>

					<div className="pp-form-row-split">
						<Select
							htmlID="hull-type"
							htmlName="hullType"
							label="Hull Type"
							placeholderText="Hull Type"
							value={vesselInfo.hullType}
							onChange={this.onChange}
							options={[{"value": 1, "text": "Planing - Hard Chine"},
												{"value": 3, "text": "Semi-Planing - Hard Chine"},
												{"value": 2, "text": "Semi-Planing - Round Bilge"},
												{"value": 4, "text": "Displacement"}]}
							disabled={this.props.disableAll}
							error={this.props.errors.hullType || false}
							required
						/>
					</div>

					<div className="pp-form-row-split">
						<Select
							htmlID="vessel-installation"
							htmlName="vesselInstallation"
							label="Vessel Installation"
							placeholderText="Vessel Installation"
							value={vesselInfo.vesselInstallation}
							onChange={this.onChange}
							options={[{"value": 1, "text": "Refit"}, {"value": 2, "text": "New Build"}]}
							disabled={this.props.disableAll}
							error={this.props.errors.vesselInstallation || false}
							required
						/>
					</div>
				</div>

				<div className="pp-form-wrapper">
					<h3 className="pp-form-title">Vessel Dimensions</h3>
					<p className="pp-form-description"><strong>Do not estimate!</strong> Accurate information will allow us to give a more accurate prediction.</p>
					<p className="pp-english-units-description">Please enter lengths in decimal feet.</p>
					{this.props.hasOverride &&
						<p className="pp-message-text">This sizing form is overriding some vessel information.</p>
					}
					{this.state.commaWarning &&
						<p className="pp-message-text">Please use a period to indicate the decimal place only.</p>
					}
					{this.state.weightWarning &&
						<p className="pp-message-text">Please be sure you are entering displacement in kgs or lbs.</p>
					}

					<div
						className="pp-form-row-split"
						data-metric="kg"
						data-english="lbs"
					>
						<Input
							type="text"
							htmlID="full-load"
							htmlName="fullLoad"
							label="Full Load Displacement"
							placeholderText="Full Load Displacement"
							value={vesselInfo.fullLoad}
							onChange={this.onChange}
							required
							disabled={this.props.disableAll}
							error={this.props.errors.fullLoad || false}
							numberOfDecimals="0"
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					<div
						className="pp-form-row-split"
						data-metric="hrs / year"
						data-english="hrs / year"
					>
						<Input
							type="text"
							htmlID="operation-hours"
							htmlName="operationHours"
							label="Hours of Operation"
							placeholderText="Hours of Operation"
							value={vesselInfo.operationHours}
							onChange={this.onChange}
							disabled={this.props.disableAll}
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					<div
						className="pp-form-row-split"
						data-metric="m"
						data-english="ft"
					>
						<Input
							type="text"
							htmlID="LOA"
							htmlName="LOA"
							label="Length Overall"
							placeholderText="LOA"
							value={vesselInfo.LOA}
							onChange={this.onChange}
							required
							disabled={this.props.disableAll}
							error={this.props.errors.LOA || false}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					<div
						className="pp-form-row-split"
						data-metric="m"
						data-english="ft"
					>
						<Input
							type="text"
							htmlID="LWL"
							htmlName="LWL"
							label="Waterline Length"
							placeholderText="LWL"
							value={vesselInfo.LWL}
							onChange={this.onChange}
							required
							disabled={this.props.disableAll}
							error={this.props.errors.LWL || false}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					<div
						className="pp-form-row-split"
						data-metric="m"
						data-english="ft"
					>
						<Input
							type="text"
							htmlID="BOA"
							htmlName="BOA"
							label="Beam Overall"
							placeholderText="BOA"
							value={vesselInfo.BOA}
							onChange={this.onChange}
							required
							disabled={this.props.disableAll}
							error={this.props.errors.BOA || false}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					<div
						className="pp-form-row-split"
						data-metric="m"
						data-english="ft"
					>
						<Input
							type="text"
							htmlID="BWL"
							htmlName="BWL"
							label="Max Waterline Beam"
							placeholderText="BWL"
							value={vesselInfo.BWL}
							onChange={this.onChange}
							required
							disabled={this.props.disableAll}
							error={this.props.errors.BWL || false}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					<div
						className="pp-form-row-split"
						data-metric="m"
						data-english="ft"
					>
						<Input
							type="text"
							htmlID="appendages"
							htmlName="appendages"
							label="Draft Without Appendages"
							placeholderText="Draft Without Appendages"
							value={vesselInfo.appendages}
							onChange={this.onChange}
							disabled={this.props.disableAll}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					<div
						className="pp-form-row-split"
						data-metric="m"
						data-english="ft"
					>
						<Input
							type="text"
							htmlID="waterline-transom"
							htmlName="waterlineTransom"
							label="Waterline Beam at Transom"
							placeholderText="WBT"
							value={vesselInfo.waterlineTransom}
							onChange={this.onChange}
							disabled={this.props.disableAll}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					<div
						className="pp-form-row-split"
						data-metric="degrees"
						data-english="degrees"
					>
						<Input
							type="text"
							htmlID="deadrise-bwl"
							htmlName="deadriseBwl"
							label="Deadrise Angle of Hull at BWL Max"
							placeholderText="DAH at BWL Max"
							value={vesselInfo.deadriseBwl}
							onChange={this.onChange}
							disabled={this.state.disableDeadrise || this.props.disableAll}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					<div
						className="pp-form-row-split"
						data-metric="degrees"
						data-english="degrees"
					>
						<Input
							type="text"
							htmlID="deadrise-transom"
							htmlName="deadriseTransom"
							label="Deadrise Angle of Hull at Transom"
							placeholderText="DAH at Transom"
							value={vesselInfo.deadriseTransom}
							onChange={this.onChange}
							disabled={this.state.disableDeadrise || this.props.disableAll}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					<div
						className="pp-form-row-split"
						data-metric="m"
						data-english="ft"
					>
						<Input
							type="text"
							htmlID="GMT"
							htmlName="GMT"
							label="Transverse Metacentric Height"
							placeholderText="GMT (Do Not Estimate)"
							value={vesselInfo.GMT}
							onChange={this.onChange}
							disabled={this.props.disableAll}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					<div
						className="pp-form-row-split"
						data-metric="m"
						data-english="ft"
					>
						<Input
							type="text"
							htmlID="GMT_est"
							htmlName="GMT_est"
							label="Transverse Metacentric Height (Estimated)"
							placeholderText="GMT (Estimated)"
							value={vesselInfo.GMT_est}
							onChange={this.onChange}
							disabled={true}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					<div
						className="pp-form-row-split"
						data-metric="s"
						data-english="s"
					>
						<Input
							type="text"
							htmlID="natural-roll-period"
							htmlName="naturalRollPeriod"
							label="Measure Natural Roll Period"
							placeholderText="Measured NRP"
							value={vesselInfo.naturalRollPeriod}
							onChange={this.onChange}
							disabled={this.props.disableAll}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					<div
						className="pp-form-row-split"
						data-metric="s"
						data-english="s"
					>
						<Input
							type="text"
							htmlID="natural-roll-period-est"
							htmlName="naturalRollPeriodEst"
							label="Measure Natural Roll Period (Estimated)"
							placeholderText="Estimated NRP"
							value={vesselInfo.naturalRollPeriod_est}
							onChange={this.onChange}
							disabled={true}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={this.enableCommaWarning}
						/>
					</div>

					{vesselInfo.modelLength !== undefined &&
					<div
						className="pp-form-row-split"
					>
						<Input
							type="text"
							htmlID="model-length"
							htmlName="modelLength"
							label="Model Length"
							placeholderText="Model Length"
							value={vesselInfo.modelLength}
							onChange={this.onChange}
							disabled={this.props.disableAll}
							numberOfDecimals="0"
							isNumber={true}
							commaWarning={false}
						/>
					</div>
					}

					{this.isCatamaran() &&
					<div
						className="pp-form-row-split"
						data-metric="m"
						data-english="ft"
					>
						<Input
							type="text"
							htmlID="demo-hull-max-BWL"
							htmlName="demoHullMaxBWL"
							label="Demi-Hull Max BWL"
							placeholderText="Demi-Hull Max BWL"
							value={vesselInfo.demoHullMaxBWL}
							onChange={this.onChange}
							disabled={this.props.disableAll}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={false}
						/>
					</div>
					}

					{this.isCatamaran() &&
					<div
						className="pp-form-row-split"
						data-metric="m"
						data-english="ft"
					>
						<Input
							type="text"
							htmlID="demo-hull-spacing-BWL"
							htmlName="demoHullSpacingBWL"
							label="Demi-Hull Spacing @BWL"
							placeholderText="Demi-Hull Spacing @BWL"
							value={vesselInfo.demoHullSpacingBWL}
							onChange={this.onChange}
							disabled={this.props.disableAll}
							numberOfDecimals="2"
							isNumber={true}
							commaWarning={false}
						/>
					</div>
					}

				</div>

				<div className="pp-form-wrapper">
					<div className="pp-form-row">
						<Textarea
							type="text"
							htmlID="notes"
							htmlName="notes"
							label="Notes"
							placeholderText="Notes"
							value={vesselInfo.notes}
							onChange={this.onChange}
							disabled={this.props.disableAll}
						/>
					</div>
				</div>
			</form>
		);
	}
}

export default VesselForm;



// WEBPACK FOOTER //
// ./src/components/VesselForm.js